import { render, staticRenderFns } from "./add-feedback-suggestion.vue?vue&type=template&id=23cadb0d&scoped=true"
import script from "./add-feedback-suggestion.ts?vue&type=script&lang=ts&external"
export * from "./add-feedback-suggestion.ts?vue&type=script&lang=ts&external"
import style0 from "./add-feedback-suggestion.scoped.scss?vue&type=style&index=0&id=23cadb0d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cadb0d",
  null
  
)

export default component.exports